import { Enum } from "./Enum";

export const UNITS = Object.freeze({
  GET: `/unit`,
  CREATE: "/unit",
  BULK_CREATE: "/unit/bulk",
  BULK_MARK_AS_SOLD: "/unit/bulk-mark-as-sold",
  MARK_ALL_AS_SOLD: "/unit/mark-all-as-sold",
  DETAIL: (id: string) => `/unit/${id}`,
  UPDATE: (id: string) => `/unit/${id}`,
  REMOVE: (id: string) => `/unit/${id}`,
});

export type E_UNITS = Enum<typeof UNITS>;
